module.exports = __webpack_public_path__ + "img/knu_gallery3.79739848.jpg";